module.exports = __webpack_public_path__ + "nc_static/media/notification status.7f525e27.svg";